<template>
	<transition name="modal">
		<div class="modal modal-overlay" :key="elKey">
			<!-- </div> @click.self="$emit('close')"> -->
			<div class="modal-window" ref="draggableContainer" id="draggable-container">
				<div class="modal-header" @mousedown="dragMouseDown" id="draggable-header">
					<slot name="title"></slot>
					<p v-if="showCloseButton" style="float: right;padding-right:10px;color:yellow;font-weight: normal;font-size: 13px;"><a href="javascript:;" @click="$emit('close')">Close</a></p>
				</div>
				<div ref="modalContent" class="modal-content">
					<slot name="body"></slot>
				</div>
				<!-- <footer class="modal-footer">
					<slot name="footer">
						<button @click="$emit('close')">닫기</button>
					</slot>
				</footer> -->
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data: function() {
		return {
			positions: {
				clientX: undefined,
				clientY: undefined,
				movementX: 0,
				movementY: 0,
			},
			elKey: 0,
		};
	},
	props: {
		modalWidth: Number,
		showCloseButton: {
			type: Boolean,
			default: true,
		},
	},
	watch: {
		modalWidth: {
			// immediate: true, // => modalWidth가 바뀌는 경우에만 update되도록
			handler() {
				if (this.modalWidth) {
					this.setModalWidth();
				} else this.elKey++;
			},
		},
	},
	methods: {
		dragMouseDown: function(event) {
			event.preventDefault();
			// get the mouse cursor position at startup:
			this.positions.clientX = event.clientX;
			this.positions.clientY = event.clientY;
			document.onmousemove = this.elementDrag;
			document.onmouseup = this.closeDragElement;
		},
		elementDrag: function(event) {
			event.preventDefault();
			this.positions.movementX = this.positions.clientX - event.clientX;
			this.positions.movementY = this.positions.clientY - event.clientY;
			this.positions.clientX = event.clientX;
			this.positions.clientY = event.clientY;
			// set the element's new position:
			this.$refs.draggableContainer.style.top = this.$refs.draggableContainer.offsetTop - this.positions.movementY + 'px';
			this.$refs.draggableContainer.style.left = this.$refs.draggableContainer.offsetLeft - this.positions.movementX + 'px';
		},
		closeDragElement() {
			document.onmouseup = null;
			document.onmousemove = null;
		},
		setModalWidth() {
			this.$nextTick(() => {
				if (this.$refs.modalContent) this.$refs.modalContent.firstChild.style['width'] = (window.innerWidth * this.modalWidth) / 100 + 'px';
			});
		},
	},
	created() {
		if (this.modalWidth) this.setModalWidth();
	},
};
</script>

<style lang="scss" scoped>
.modal {
	&.modal-overlay {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		z-index: 30;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
	}
	&-window {
		background: #fff;
		border-radius: 4px;
		overflow: hidden;
	}
	&-header {
		color: #fff;
		font-weight: bold;
		font-size: 15px;
		line-height: 32px;
		padding: 0 0 0 12px;
		margin-bottom: 0px !important;
		background: #2267bb;
		//padding: 10px 10px 0px 10px;
	}
	&-content {
		padding: 5px 10px 0px 10px;
		overflow-y: auto;
	}
	&-footer {
		background: #ccc;
		padding: 10px 0px 0px 0px;
		text-align: right;
	}
}

#draggable-container {
	position: absolute;
	z-index: 9;
}
#draggable-header {
	z-index: 10;
}
// .modal-enter-active,
// .modal-leave-active {
// 	transition: opacity 0.1s;
// 	.modal-window {
// 		transition: opacity 0.1s, transform 0.1s;
// 	}
// }
// .modal-leave-active {
// 	transition: opacity 0.1s ease 0.1s;
// }
// .modal-enter,
// .modal-leave-to {
// 	opacity: 0;
// 	.modal-window {
// 		opacity: 0;
// 		transform: translateY(-20px);
// 	}
// }
</style>
